import { Navigate, Outlet, useLocation } from "react-router";
import type { AccessLevel } from "@fortex/api";
import { EmptyState } from "@fortex/map";
import { loginPath } from "../config";
import { useAuth, useLabels } from "./context";

export function returnUrlOf(pathname: string, search: string): string {
  return `${pathname}${search}`;
}

export function RequireAuth() {
  const token = useAuth(a => a.token);
  const location = useLocation();

  if (token === null) return <Navigate to={loginPath(returnUrlOf(location.pathname, location.search))} replace />;

  return <Outlet />;
}

export function RequireFeature({ feature, level = "ReadOnly" }: { feature: string; level?: Exclude<AccessLevel, "None"> }) {
  const labels = useLabels();
  const token = useAuth(a => a.token);
  const allowed = useAuth(a => a.can(feature, level));
  const location = useLocation();

  if (token === null) return <Navigate to={loginPath(returnUrlOf(location.pathname, location.search))} replace />;
  if (!allowed) return <EmptyState icon="warning" title={labels.accessDenied} />;

  return <Outlet />;
}
